import useResponsive from 'src/hooks/useResponsive';

export default function Desktop({ children }: any) {
  return useResponsive('up', 'sm') ? children : null;
}
